import { Form } from "antd";
import React from "react";
import styled from "styled-components";
import Button from "../../atoms/Button";
import Input from "../../atoms/Input";

interface Props {
  street?: string;
  detail?: string;
  onClick: (e: any) => void;
  onChange: (e: any) => void;
}
const { Item } = Form;
const SearchAddressInputs: React.FC<Props> = ({
  street,
  detail,
  onChange,
  onClick,
}) => {
  return (
    <StyledContainer>
      <StyledAddressWrapper>
        <StyledInputWrapper>
          <Item noStyle name="street" />
          <Input
            placeholder="매장 주소를 입력해주세요"
            value={street}
            onChange={() => {}}
            onClick={onClick}
          />
        </StyledInputWrapper>
        <StyledButtonWrapper>
          <Button ghost onClick={onClick}>
            주소 검색
          </Button>
        </StyledButtonWrapper>
      </StyledAddressWrapper>
      <StyledDetailAddressWrapper>
        <Item noStyle name="detail" />
        <Input
          placeholder="상세 주소를 입력해주세요"
          value={detail}
          onChange={onChange}
        />
      </StyledDetailAddressWrapper>
    </StyledContainer>
  );
};
export default SearchAddressInputs;
const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 480px;
`;

const StyledAddressWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  justify-content: space-between;
  margin-bottom: 12px;
`;
const StyledInputWrapper = styled.div`
  width: 388px;
`;

const StyledButtonWrapper = styled.div``;

const StyledDetailAddressWrapper = styled.div`
  width: 100%;
`;
